import React from 'react';
import { GAMES_LIST } from '../../constants/dataTestIds';
import { getDataTestAttributes } from '../../utils/testing-locators';
import GamesGrid from '../GamesGrid/GamesGrid';
import ErrorRedirect from '../ErrorRedirect/ErrorRedirect';
import { useRecentGames } from '../../hooks/useRecentGames';
import { useElementRef } from '../../hooks/useElementRef';
import { useGamesCountInWidget } from '../../pages/Main/hooks';
import ScrollRestoration from '../ScrollRestoration/ScrollRestoration';
import { RECENT_CATEGORY } from '../../constants/navigation';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../constants/analytics';

const updateAnalyticsData = (analyticsData) => {
  const result = {
    ...(analyticsData || {}),
    screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.RECENT_GAME,
  };
  return result;
};

const RecentGames = ({ analyticsData }) => {
  const { data, isLoading, error } = useRecentGames({
    _limit: -1,
  });

  const [element, ref] = useElementRef();
  const limit = useGamesCountInWidget(element);

  if (error) {
    return <ErrorRedirect error={error} />;
  }

  const updatedAnalyticsData = updateAnalyticsData(analyticsData);
  return (
    <ScrollRestoration>
      <div ref={ref}>
        <GamesGrid
          isLoading={isLoading}
          games={data ?? []}
          gamesCount={limit}
          dataAttributes={getDataTestAttributes(GAMES_LIST)}
          categoryId={RECENT_CATEGORY.id}
          analyticsData={updatedAnalyticsData}
        />
      </div>
    </ScrollRestoration>
  );
};

export default RecentGames;
